import React from 'react';
import DocumentTitle from 'react-document-title';
import NotFoundError from 'components/errors/notFoundError';

export default function () {
    return (
        <DocumentTitle title="Page Not Found">
            <NotFoundError />
        </DocumentTitle>
    );
}



// WEBPACK FOOTER //
// ./app/assets/javascripts/views/routeNotFound.jsx